import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Loader2, MonitorSmartphone, ShieldAlert, ShieldCheck } from "lucide-react";

export const LoginActivity = ({ email, compact }) => {
  const { data = [], isLoading } = useQuery({
    queryKey: ["login-activity", email || "me"],
    queryFn: async () => (await api.get("/auth/activity", { params: email ? { email } : {} })).data,
  });
  if (isLoading) return <div className="flex justify-center py-6"><Loader2 className="w-5 h-5 animate-spin text-muted-foreground" /></div>;
  if (data.length === 0) return <p className="text-sm text-muted-foreground text-center py-6" data-testid="login-activity-empty">No sign-ins recorded yet.</p>;
  return (
    <div className="divide-y divide-border" data-testid="login-activity-list">
      {data.slice(0, compact ? 8 : 20).map((a) => (
        <div key={a.id} className="flex items-center gap-3 py-2.5" data-testid={`login-activity-row-${a.id}`}>
          {a.success ? <ShieldCheck className="w-4 h-4 text-emerald-600 shrink-0" /> : <ShieldAlert className="w-4 h-4 text-destructive shrink-0" />}
          <div className="min-w-0 flex-1">
            <p className="text-sm truncate flex items-center gap-1.5"><MonitorSmartphone className="w-3.5 h-3.5 text-muted-foreground" /> {a.device}</p>
            <p className="text-[11px] text-muted-foreground font-mono">{new Date(a.at).toLocaleString("en-IN")} • IP {a.ip}</p>
          </div>
          <span className={`text-[10px] font-mono px-2 py-0.5 rounded-full ${a.success ? "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-400" : "bg-rose-50 text-rose-700 dark:bg-rose-950/50 dark:text-rose-400"}`}>
            {a.success ? "Success" : "Failed"}
          </span>
        </div>
      ))}
    </div>
  );
};
